module.exports = __webpack_public_path__ + "static/teeth-324d4840f8560a250c2d2f34fe244c8c.jpg";